import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

export default defineNuxtPlugin(async ({ $pinia }) => {
   $pinia.use(piniaPluginPersistedstate);
});